import { Container } from "./styles";
import ScrollAnimation from "react-animate-on-scroll";
import Illustration from "../../assets/illustration.svg";
import whatsapp from "../../assets/whatsapp.svg";
import linkedin from "../../assets/linkedin.svg";
import instagram from "../../assets/instagram.svg";
import facebook from "../../assets/facebook.svg";
import Hello from "../../assets/Hello.gif";

// Type assertion for ScrollAnimation
const AnimatedScroll = ScrollAnimation as any;
export function Hero() {
  return (
    <Container id="home">
      <div className="hero-text">
        <AnimatedScroll animateIn="fadeInUp">
          <p>
            Hello <img src={Hello} alt="Hello" width="20px" />, I'm
          </p>
        </AnimatedScroll>
        <AnimatedScroll animateIn="fadeInUp" delay={0.2 * 1000}>
          <h1>Muzzamal Rashid</h1>
        </AnimatedScroll>
        <AnimatedScroll animateIn="fadeInUp" delay={0.4 * 1000}>
          <h3>Software Quality Assurance Engineer</h3>
        </AnimatedScroll>
        <AnimatedScroll animateIn="fadeInUp" delay={0.6 * 1000}>
          <p className="small-resume">QA Engineer with 5 years of experience in ensuring software quality for leading Canadian companies</p>
        </AnimatedScroll>
        <AnimatedScroll animateIn="fadeInUp" delay={0.8 * 1000}>
          <a href="#contact" className="button">
            Contact
          </a>
        </AnimatedScroll>
        <AnimatedScroll animateIn="fadeInUp" delay={1 * 1000}>
          <div className="social-media">
            <a
              href="https://linkedin.com/in/muzzamal-rashid-2468481ab"
              target="_blank"
              rel="noreferrer"
            >
              <img src={linkedin} alt="LinkedIn" />
            </a>
            {/* <a
              href="https://github.com/muzzamalrashid"
              target="_blank"
              rel="noreferrer"
            >
              <img src={github} alt="GitHub" />
            </a> */}
            <a
              href="https://www.facebook.com/profile.php?id=100010563672115"
              target="_blank"
              rel="noreferrer"
            >
              <img src={facebook} alt="Facebook" />
            </a>
            <a
              href="https://www.instagram.com/muzamilrasheed1460/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={instagram} alt="Instagram" />
            </a>
            <a
              href={`https://api.whatsapp.com/send/?phone=%2B923208460396&text=Hello+Muzzamal+I+found+your+contact+through+portfolio+site.%0A%0A`}
              target="_blank"
              rel="noreferrer"
            >
              <img src={whatsapp} alt="Whatsapp" />
            </a>
          </div>
        </AnimatedScroll>
      </div>
      <div className="hero-image">
        <AnimatedScroll animateIn="fadeInRight" delay={1 * 1000}>
          <img src={Illustration} alt="Ilustração" />
        </AnimatedScroll>
      </div>
    </Container>
  );
}
